import { CHANGE_PRIVACY_POLICY } from '../actions/types';

const defaultState = false;

export const applicationSavePrivacyPolicyReducer = (previousState = defaultState, action) => {
  let hidePrivacyNotification = previousState;
  if (action.type === CHANGE_PRIVACY_POLICY) {
    hidePrivacyNotification = action.payload;
  }
  return hidePrivacyNotification;
};
